<template>
    <div class='download-block'>
        <div class='title'>
            Download
        </div>
        <el-divider></el-divider>

         <!-- <i style="padding-left:2em;color:#b4b4b4">(Click to download)</i>
        <p class="downloader"><a href="./static/code/scan-atac-sim-files.tar.gz" download="scan-atac-sim-files.tar.gz">scan-atac-sim-files.tar.gz</a>
         -- <i>Download all files together</i></p><br/>
        
        <p class="downloader"><a href="./static/code/hg38.blacklist.bed.gz" download="hg38.blacklist.bed.gz">hg38.blacklist.bed.gz</a>
         -- <i>The ENCODE published black list regions. Reads from these regions are excluded in the simulation.</i></p>

         <p class="downloader"><a href="./static/code/SCAN-ATAC_Preprocessing.ipynb" download="SCAN-ATAC_Preprocessing.ipynb">SCAN-ATAC_Preprocessing.ipynb </a>
         -- <i>Jupyter Notebook file that performs data preprocessing in an interactive manner to allow for custom exploration, 
             <span style='margin-left:19em'>processing, and visualizations.</span></i></p>

         <p class="downloader"><a href="./static/code/SCAN-ATAC_Preprocessing.py" download="SCAN-ATAC_Preprocessing.py">SCAN-ATAC_Preprocessing.py</a>
         -- <i>Python script for data preprocessing</i></p>

         <p class="downloader"><a href="./static/code/run.sh" download="run.sh">run.sh</a>
         -- <i>A bash script that runs the Single-Cell Simulation steps</i></p>

         <p class="downloader"><a href="./static/code/Makefile" download="Makefile">Makefile</a>
         -- <i>Makefile to compile and build the Single-Cell Simulation steps in C++</i></p>

         <p class="downloader"><a href="./static/code/weighted_sampling.cpp" download="weighted_sampling.cpp">weighted_sampling.cpp</a>
         -- <i>Script that performs weighted reservoir sampling to sample regions based on read coverage</i></p>

         <p class="downloader"><a href="./static/code/uniform_sampling.cpp" download="uniform_sampling.cpp">uniform_sampling.cpp</a>
         -- <i>Script that samples reads in a region from a uniform distributionr</i></p>

         <p class="downloader"><a href="./static/code/tools.h" download="tools.h">tools.h</a>
         -- <i>Helper functions header file implemented for Single-Cell Simulation Steps</i></p>

         <p class="downloader"><a href="./static/code/tools.cpp" download="tools.cpp">tools.cpp</a>
         -- <i>Helper functions source code implemented for Single-Cell Simulation Steps</i></p> -->
        
        <div class='table-part'>
        <el-table
            :data="tableData"
            stripe
            style="width: 100%">


            <el-table-column
            prop="File"
            label="File Name"
            width="360">
            </el-table-column>


            <el-table-column
            prop="Description"
            label="Description"
            >
            </el-table-column>

            <el-table-column
            width="180"
            label="Download"
            >
            <template slot-scope="scope">
                <el-button style='margin-left:20px;font-weight:bold' @click="handleClick(scope.row)" type="text" size="large" icon="el-icon-download"></el-button>
            </template>
            </el-table-column>


        </el-table>
        </div>
    </div>    
</template>

<script>
  export default {
    data() {
      return {

        tableData: [
            {
                File:'code.tar.gz',
                Description:'Download all files together',
            },
            {
                File:'hg38.blacklist.bed.gz',
                Description:'The ENCODE published black list regions. Reads from these regions are excluded in the simulation.',
            },
            {
                File:'SCAN-ATAC_Preprocessing.ipynb',
                Description:'Jupyter Notebook file that performs data preprocessing in an interactive manner to allow for custom exploration, processing, and visualizations.',
            },
            {
                File:'preprocess.py',
                Description:'Python script for data preprocessing.',
            },
            {
                File:'run.sh',
                Description:'A bash script with default parameters to quick start simulations',
            },
            {
                File:'Makefile',
                Description:'Makefile to compile and build the Single-Cell Simulation steps in C++',
            },
            {
                File:'weighted_sampling.cpp',
                Description:'Script that performs weighted reservoir sampling to sample regions based on read coverage',
            },
            {
                File:'uniform_sampling.cpp',
                Description:'Script that samples reads in a region from a uniform distribution',
            },
            {
                File:'tools.h',
                Description:'Helper functions source code implemented for Single-Cell Simulation Steps',
            },
            {
                File:'tools.cpp',
                Description:'Helper functions source code implemented for Single-Cell Simulation Steps',
            },
            
            ]
      }
    },
    methods:{
        handleClick(value){
            console.log(value);
            var url = './static/code/'+value.File
            window.open(url)

        }
    }
  }
</script>

<style scoped>
.download-block{
    box-sizing: border-box;
    text-align:left;
    padding:20px;
    font-size:16px;
}
.table-part{
    width:95%;
    margin:0 auto;
}
.download-block .sub-title{
        color:white;
        margin-top:2%;
        margin-bottom: 2%;
        padding-left:2em;
        padding-right:2em;
        font-weight: bold;
        font-size:16px;
        width:fit-content;
        background-color:rgb(0,100,164);
        height:2em;
        line-height:2em;
        border-radius:20px;
    }
.downloader a{
    text-decoration: none;
    margin-left: 2em;

}
.title{
    font-weight: bold;
    font-size:20px;
    padding-left:40px;
}
.function-name{
    width:fit-content;
    display: inline-block;
    font-weight:bold;
    font-size:16px;
    padding-bottom: 4px;
    margin-left:1em;
    border-bottom: 2px rgb(0,100,164) solid;
}
.el-icon-download{
    font-size: 24px;
    font-weight: bold;

}
.guide-block{

    width:90%;
    padding:10px 20px;
    margin:0px auto 1.5em;
    background-color: #F6F8FA;
    /* min-height:300px; */
    border-radius: 20px;
    font-size:14px;

}
</style>


// WEBPACK FOOTER //
// src/view/download/index.vue